// Source normalization entry for .luis compiler preprocessing.
// It strips comments and fixes common semicolon issues with warnings.
import type { LuisCompileWarning } from './types'
import { stripLuisComments } from './normalize/comments'
import { collectMissingSemicolonWarnings } from './normalize/warnings'
import { normalizeVarSemicolons } from './normalize/semicolons'

type NormalizeDiagnostics = {
  source: string
  warnings: LuisCompileWarning[]
}

// Keep backward compatibility for callers that only need normalized source text.
export function normalizeSource(source: string): string {
  // Return normalized source without diagnostics payload.
  return normalizeSourceWithDiagnostics(source).source
}

// Normalize source and return soft warnings for recoverable syntax issues.
export function normalizeSourceWithDiagnostics(source: string, collectWarnings = true): NormalizeDiagnostics {
  const withoutComments = (source.includes('/*') || source.includes('//')) ? stripLuisComments(source) : source
  const warnings = collectWarnings ? collectMissingSemicolonWarnings(withoutComments) : []
  const normalized = normalizeVarSemicolons(withoutComments)

  // Return normalized source and collected warning list.
  return {
    source: normalized,
    warnings,
  }
}
